import { createSlice } from '@reduxjs/toolkit';


interface modalI {
  isOpen: boolean;
  type: string;
}
const initialState: modalI = {
  isOpen: true,
  type: 'StatisticAll',
};

const statisticSlice = createSlice({
  name: 'statisticsSlice',
  initialState,
  reducers: {
    callModal: (state) => {
      state.isOpen = true;
    },
    closeModal: (state) => {
      state.isOpen = false;
    },
    setStatisticAll: (state) => {
        state.type = 'StatisticAll';
    },
    setStatisticRange: (state) => {
        state.type = 'StatisticRating';
    },
  },
});


const { actions, reducer } = statisticSlice;
export default reducer;
export const { callModal, closeModal, setStatisticAll, setStatisticRange } = actions;